"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatahubViewCreateMentorshipService = void 0;
var datahubViewCreateMentorshipService_1 = require("./datahubViewCreateMentorshipService");
Object.defineProperty(exports, "DatahubViewCreateMentorshipService", { enumerable: true, get: function () { return __importDefault(datahubViewCreateMentorshipService_1).default; } });
